<template>
    <v-dialog v-model="suggestedMessagesDialog" max-width="700" persistent scrollable>
        <v-card>
            <v-card-title class="headline grey lighten-2">
                <v-icon left>mdi-lightbulb-on</v-icon>
                Sugerencias de respuesta (IA)
            </v-card-title>

            <v-card-text class="pt-6">
                <p class="body-2 grey--text text--darken-1 mb-4">
                    Elige una de las siguientes opciones o adáptala antes de enviar:
                </p>

                <v-list two-line>
                    <v-list-item v-for="(message, index) in suggestedMessages" :key="index" class="mb-3" ripple
                        @click="copyToClipboard(message)">
                        <v-list-item-content>
                            <v-list-item-title class="font-weight-medium">
                                Opción {{ index + 1 }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="mt-2 grey--text text--darken-3">
                                {{ message }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-btn icon small @click.stop="copyToClipboard(message)">
                                <v-icon color="grey darken-1">mdi-content-copy</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="closeDialog">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'SuggestedMessagesDialog',

    props: {
        suggestedMessagesDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        suggestedMessages: {
            type: Array,
            required: true,
            default: function () {
                return []
            }
        }
    },

    data: function () {
        return {
            dialog: false
        }
    },

    methods: {
        closeDialog() {
            this.$emit("closeSuggestedMessagesDialog")
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.$emit("showSnackbar",'Copiado al portapapeles')
            })
        }
    }
}
</script>

<style scoped>
.v-list-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
    cursor: pointer;
}
</style>